module.exports = __webpack_public_path__ + "static/img/induceBanner.85eb9c44.jpg";